// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__DwtSp","spinner":"Loader_spinner__wDq1e","spin":"Loader_spin__ddwRw"};